import { createInjectable } from 'ngxtension/create-injectable';

// Wraps window.location.reload() so it can be mocked in tests
export const WindowReloadService = createInjectable(
  () => ({
    reload: () => window.location.reload(),
  }),
  { providedIn: 'root' },
);
